import React, { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import SidebarPageLayout from '../../components/layout/SidebarPageLayout';

function Support() {

  useEffect(() => {
    document.title = "Vivosol Plant Performance Insights Hub | Help / Support";
  }, []);

  return (
    <SidebarPageLayout>
      <div className="content p-5">
        <h1>Support</h1>
      </div>
    </SidebarPageLayout>
  );
}

export default Support;
